import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import api, { API_BASE_URL } from './api';
import { useAuth } from './AuthContext';
import './themes/Theme_web_DK.css';

export const PRIVATE_THEME = 'Theme_web_DK';
export const LOGIN_THEME_TOKEN_KEY = 'otoflow_login_tema_token';
const ThemeContext = createContext(null);
const DEFAULT_STATE = { owner: undefined, deger: PRIVATE_THEME, temalar: [], ready: false };

export function ThemeProvider({ children }) {
  const { kullanici } = useAuth();
  const owner = kullanici?.id ?? null;
  const [state, setState] = useState(DEFAULT_STATE);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const current = state.owner === owner ? state : DEFAULT_STATE;
  const privateAllowed = !!kullanici && current.temalar.some((t) => t.id === PRIVATE_THEME);

  useEffect(() => {
    let active = true;
    setError('');
    const load = async () => {
      try {
        let data = { deger: PRIVATE_THEME, temalar: [] };
        if (owner !== null) {
          ({ data } = await api.get('/ayarlar/tema'));
        } else {
          const token = localStorage.getItem(LOGIN_THEME_TOKEN_KEY);
          if (token) {
            ({ data } = await axios.get(`${API_BASE_URL}/auth/login-theme`, {
              headers: { Authorization: `Bearer ${token}` }, timeout: 10000,
            }));
          }
        }
        // Older API workers can still return the former implicit "classic"
        // preference. Treat it as DKD here as well, so every account receives
        // the new default even while a stale worker is being restarted.
        const deger = !data.deger || data.deger === 'classic' ? PRIVATE_THEME : data.deger;
        if (active) setState({ owner, deger, temalar: data.temalar || [], ready: true });
      } catch {
        if (active) setState({ owner, deger: PRIVATE_THEME, temalar: [], ready: true });
      }
    };
    load();
    return () => { active = false; };
  }, [owner]);

  useEffect(() => {
    document.documentElement.dataset.theme = current.deger;
    return () => { document.documentElement.dataset.theme = PRIVATE_THEME; };
  }, [current.deger]);

  const selectTheme = async (deger) => {
    if (saving || !current.temalar.some((t) => t.id === deger)) return false;
    setSaving(true);
    setError('');
    try {
      const { data } = await api.post('/ayarlar/tema', { deger });
      setState((previous) => previous.owner === owner ? { ...previous, deger: data.deger } : previous);
      return true;
    } catch {
      setError('Tema kaydedilemedi. Lütfen tekrar deneyin.');
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme: current.deger, ready: current.ready, privateAllowed, selectTheme, saving, error }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
